module.exports = __webpack_public_path__ + "img/mac-icon5.a27077a.png";